// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","caption":"_1dJD2pSCq2-UhXWE_3mRfd","errorRed":"#ff2a2a","textGreen":"#009e66","button":"YKJ-clv1Q4QI3JaO_hbcq","successText":"_2_2PWRe-fuUrihh6i77A_a _2lYHSCAcM6vA2s-47YYZeS","input":"_3Tbh6vev3OVJg7181ODKDT","recaptcha":"_2gWhdf743J4R0Dlauw1JpH","errorMessage":"_2nPuROvR_JtgdiohNp2E8U _1dJD2pSCq2-UhXWE_3mRfd","recoverAccountLink":"_1d_fnLUnCCnTmGPXRZV0fW _1dJD2pSCq2-UhXWE_3mRfd","btn":"_1jvqcYG759VZfE10wO1Ept","btnAccept":"Wyd_N-1ZHhRpeMN48_P9a"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/forgot-password/data-form/DataForm.css
// module id = 847
// module chunks = 0